module.exports = __webpack_public_path__ + "img/8-2.c3f5b369.jpg";